export default "__VITE_PUBLIC_ASSET__1116dcbc__"